<template>
  <div>
    <form>
      <div class="row top">
        <div class="row">
          <div class="col-md-2">
            <back-button returnUrl="/parameters"></back-button>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <h4><u>Γενικές Παράμετροι</u></h4>
          </div>
        </div>

        <div>
          <DxLoadIndicator
            id="image-indicator"
            :height="40"
            :width="40"
            :visible="loadIndicatorVisible"
          />
        </div>
      </div>

      <div class="row" style="margin-top: 2rem" v-if="globalParams != null">
        <div class="col-md-10 col-md-offset-1 tabs-container">
          <ul class="nav nav-tabs">
            <li class="active">
              <a data-toggle="tab" href="#General">Γενικά</a>
            </li>
            <li><a data-toggle="tab" href="#Email">Email</a></li>
            <li>
              <a data-toggle="tab" href="#PrivacyPolicy"
                >Πολιτική προστασίας δεδομένων</a
              >
            </li>
            <li><a data-toggle="tab" href="#TermsText">Όροι χρήσης</a></li>
            <li><a data-toggle="tab" href="#Settings">Settings</a></li>
          </ul>

          <div
            class="tab-content forms-style"
            style="padding-top: 20px; min-height: 200px"
          >
            <!-- Γενικά -->
            <div
              id="General"
              class="tab-pane fade in active col-lg-8 col-xl-5 col-md-offset-2"
            >
              <div class="form-group">
                <label
                  for="daysForCorrections"
                  class="control-label"
                  style="width: 270px"
                  >Όριο ημερών για διόρθωση παρουσιών</label
                >
                <input
                  type="number"
                  class="form-field"
                  id="DaysForCorrections"
                  v-model="globalParams.DaysForCorrections"
                  required
                />
              </div>

              <div class="form-group">
                <label
                  for="allowUnlock"
                  class="col-sm-4 control-label"
                  style="width: 270px"
                  >Επιτρέπεται ξεκλείδωμα
                </label>
                <input
                  type="checkbox"
                  id="allowUnlock"
                  v-model="globalParams.AllowUnlock"
                />
              </div>
              <div class="form-group">
                <label
                  for="showSmsIcon"
                  class="col-sm-4 control-label"
                  style="width: 270px"
                  >Εμφάνιση Εικονιδίου για Αποστολή SMS
                </label>
                <input
                  type="checkbox"
                  id="allowUnlock"
                  v-model="globalParams.ShowSmsIcon"
                />
              </div>
            </div>

            <!-- Παράμετροι Email -->
            <div id="Email" class="tab-pane col-lg-8 col-xl-5 col-md-offset-2">
              <div class="form-group">
                <label for="mailCredentialsLogin" class="col-sm-3 control-label"
                  >Όνομα χρήστη</label
                >
                <input
                  type="text"
                  class="form-field"
                  id="mailCredentialsLogin"
                  v-model="globalParams.MailCredentialsLogin"
                  required
                />
              </div>
              <div class="form-group">
                <label
                  for="mailCredentialsPassword"
                  class="col-sm-3 control-label"
                  >Συνθηματικό</label
                >
                <input
                  type="password"
                  class="form-field"
                  id="mailCredentialsPassword"
                  v-model="globalParams.MailCredentialsPassword"
                  required
                />
              </div>
              <div class="form-group">
                <label
                  for="mailSmtpClientAddress"
                  class="col-sm-3 control-label"
                  >Mail server address</label
                >
                <input
                  type="text"
                  class="form-field"
                  id="mailSmtpClientAddress"
                  v-model="globalParams.MailSmtpClientAddress"
                  required
                />
              </div>
              <div class="form-group">
                <label for="mailSmtpClientPort" class="col-sm-3 control-label"
                  >Mail server port</label
                >
                <input
                  type="number"
                  class="form-field"
                  id="mailSmtpClientPort"
                  v-model="globalParams.MailSmtpClientPort"
                  required
                />
              </div>
              <div class="form-group">
                <label for="mailSubject" class="col-sm-3 control-label"
                  >Τίτλος EMail
                </label>
                <input
                  type="text"
                  class="form-field"
                  id="mailSubject"
                  v-model="globalParams.MailSubject"
                  required
                />
              </div>
              <div class="form-group">
                <label for="MailUseSsl" class="col-sm-3 control-label"
                  >Χρήση SSL
                </label>
                <input
                  type="checkbox"
                  id="mailFrom"
                  v-model="globalParams.MailUseSsl"
                />
              </div>
              <div class="form-group">
                <label for="mailEmailCc" class="col-sm-3 control-label"
                  >Κοινοποίηση Email
                </label>
                <input
                  type="text"
                  class="form-field"
                  id="mailEmailCc"
                  v-model="globalParams.MailEmailCc"
                />
              </div>
              <div class="form-group">
                <label for="logoForEmail" class="col-sm-3 control-label"
                  >Logo για Email
                </label>
                <input
                  type="text"
                  class="form-field"
                  id="logoForEmail"
                  v-model="globalParams.LogoForEmail"
                />
              </div>
            </div>

            <!-- Πολιτική Προστασίας -->
            <div id="PrivacyPolicy" class="tab-pane col-md-12">
              <DxHtmlEditor
                height="600px"
                v-model="globalParams.PrivacyPolicyText"
              >
                <DxMediaResizing :enabled="true" />
                <DxToolbar :multiline="isMultiline">
                  <DxItem format-name="undo" />
                  <DxItem format-name="redo" />
                  <DxItem format-name="separator" />
                  <DxItem :format-values="sizeValues" format-name="size" />
                  <DxItem :format-values="fontValues" format-name="font" />
                  <DxItem format-name="separator" />
                  <DxItem format-name="bold" />
                  <DxItem format-name="italic" />
                  <DxItem format-name="strike" />
                  <DxItem format-name="underline" />
                  <DxItem format-name="separator" />
                  <DxItem format-name="alignLeft" />
                  <DxItem format-name="alignCenter" />
                  <DxItem format-name="alignRight" />
                  <DxItem format-name="alignJustify" />
                  <DxItem format-name="separator" />
                  <DxItem format-name="orderedList" />
                  <DxItem format-name="bulletList" />
                  <DxItem format-name="separator" />
                  <DxItem :format-values="headerValues" format-name="header" />
                  <DxItem format-name="separator" />
                  <DxItem format-name="color" />
                  <DxItem format-name="background" />
                  <DxItem format-name="separator" />
                  <DxItem format-name="link" />
                  <DxItem format-name="image" />
                  <DxItem format-name="separator" />
                  <DxItem format-name="clear" />
                  <DxItem format-name="codeBlock" />
                  <DxItem format-name="blockquote" />
                  <DxItem format-name="separator" />
                  <DxItem format-name="insertTable" />
                  <DxItem format-name="deleteTable" />
                  <DxItem format-name="insertRowAbove" />
                  <DxItem format-name="insertRowBelow" />
                  <DxItem format-name="deleteRow" />
                  <DxItem format-name="insertColumnLeft" />
                  <DxItem format-name="insertColumnRight" />
                  <DxItem format-name="deleteColumn" />
                </DxToolbar>
              </DxHtmlEditor>
            </div>

            <!-- Όροι Χρήσης -->
            <div id="TermsText" class="tab-pane col-md-12">
              <DxHtmlEditor height="600px" v-model="globalParams.TermsText">
                <DxMediaResizing :enabled="true" />
                <DxToolbar :multiline="isMultiline">
                  <DxItem format-name="undo" />
                  <DxItem format-name="redo" />
                  <DxItem format-name="separator" />
                  <DxItem :format-values="sizeValues" format-name="size" />
                  <DxItem :format-values="fontValues" format-name="font" />
                  <DxItem format-name="separator" />
                  <DxItem format-name="bold" />
                  <DxItem format-name="italic" />
                  <DxItem format-name="strike" />
                  <DxItem format-name="underline" />
                  <DxItem format-name="separator" />
                  <DxItem format-name="alignLeft" />
                  <DxItem format-name="alignCenter" />
                  <DxItem format-name="alignRight" />
                  <DxItem format-name="alignJustify" />
                  <DxItem format-name="separator" />
                  <DxItem format-name="orderedList" />
                  <DxItem format-name="bulletList" />
                  <DxItem format-name="separator" />
                  <DxItem :format-values="headerValues" format-name="header" />
                  <DxItem format-name="separator" />
                  <DxItem format-name="color" />
                  <DxItem format-name="background" />
                  <DxItem format-name="separator" />
                  <DxItem format-name="link" />
                  <DxItem format-name="image" />
                  <DxItem format-name="separator" />
                  <DxItem format-name="clear" />
                  <DxItem format-name="codeBlock" />
                  <DxItem format-name="blockquote" />
                  <DxItem format-name="separator" />
                  <DxItem format-name="insertTable" />
                  <DxItem format-name="deleteTable" />
                  <DxItem format-name="insertRowAbove" />
                  <DxItem format-name="insertRowBelow" />
                  <DxItem format-name="deleteRow" />
                  <DxItem format-name="insertColumnLeft" />
                  <DxItem format-name="insertColumnRight" />
                  <DxItem format-name="deleteColumn" />
                </DxToolbar>
              </DxHtmlEditor>
            </div>
            <div
              id="Settings"
              class="tab-pane fade in col-lg-8 col-xl-5 col-md-offset-2"
            >
              <div v-for="(setting, index) in settings" :key="index">
                <div class="form-group">
                  <label class="col-sm-3 control-label"
                    >{{ setting.Name }}
                  </label>
                  <input
                    class="form-field"
                    type="text"
                    :id="setting.id"
                    v-model="setting.Value"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="globalParams != null">
        <div class="col-md-10 col-md-offset-1">
          <div class="forms-style">
            <button type="button" class="pull-right" @click="save">
              Αποθήκευση
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import router from "../../router";
import mainService from "../../services/mainService";
import notify from "devextreme/ui/notify";
import BackButton from "../../components/shared/backButton";
import { DxLoadIndicator } from "devextreme-vue/load-indicator";
import {
  DxHtmlEditor,
  DxToolbar,
  DxMediaResizing,
  DxItem,
} from "devextreme-vue/html-editor";

export default {
  components: {
    BackButton,
    DxLoadIndicator,
    DxHtmlEditor,
    DxMediaResizing,
    DxToolbar,
    DxItem,
  },
  data() {
    return {
      loadIndicatorVisible: false,
      globalParams: null,
      settings: null,
      markup: "",
      sizeValues: ["8pt", "10pt", "12pt", "14pt", "18pt", "24pt", "36pt"],
      fontValues: [
        "Arial",
        "Courier New",
        "Georgia",
        "Impact",
        "Lucida Console",
        "Tahoma",
        "Times New Roman",
        "Verdana",
      ],
      headerValues: [false, 1, 2, 3, 4, 5],
      isMultiline: true,
    };
  },
  methods: {
    async save() {
      const res = await mainService.post(
        "/globalParams/UpdateGlobalParams",
        this.globalParams
      );
      const res2 = await mainService.post(
        "/settings/UpdateSettings",
        this.settings
      );
      debugger;
      if (res.data.Message == null) {
        notify("H αποθήκευση έγινε επιτυχώς", "success", 1000);
      } else {
        notify(`${res.data.Message}`, "warning", 3000);
      }
    },
  },
  computed: {},
  watch: {},

  async mounted() {
    this.loadIndicatorVisible = true;
    const res = await mainService.get(`/globalParams/GetGlobalParams`);
    this.globalParams = res.data;
    const settings = await mainService.get(`/settings/GetSettings`);
    this.settings = settings.data;
    this.loadIndicatorVisible = false;
  },
};
</script>
<style lang="scss" scoped>
.dx-quill-container.ql-container {
  background: white;
}

#PrivacyPolicy,
#TermsText {
  margin-bottom: 20px;
}
.forms-style {
  label {
    width: 200px;
  }
  button {
    margin-top: -60px;
  }
}
input[type="checkbox"] {
  margin: 1px 0 0 5px;
  width: 40px;
  height: 40px;
}
.nav-tabs {
  border-bottom: 1px solid white;
  margin-top: -44px;
  > li:not(.active) {
    > a {
      background: #ccc;
    }
  }
}

.tabs-container {
  border-left: 1px solid white;
  border-bottom: 1px solid white;
  border-radius: 2px;
  border-right: 1px solid white;
  padding: 0;
  margin-top: 20px;
  padding-bottom: 60px;
}
</style>
